module.exports = {"en-US":{"notifications":{"index":{"title":"Notifications","empty":"No results","unread":"Only unread notifications"}}}}